import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { fmt, errMsg, bizSlug } from "@/lib/api";
import { useBrand, Branded, BrandLogo, brandName, PoweredBy } from "@/components/Brand";
import { SlotPicker } from "@/components/SlotPicker";

const pub = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
pub.interceptors.request.use((cfg) => { const b = bizSlug(); if (b) cfg.params = { ...(cfg.params || {}), b }; return cfg; });

export default function Rebook() {
  const brand = useBrand();
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [slot, setSlot] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { pub.get(`/public/rebook/${token}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);

  const book = async () => {
    setBusy(true); setErr("");
    try { const r = await pub.post(`/public/rebook/${token}`, { startAt: slot }); setD(r.data); } catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Branded brand={brand}>
    <div className="login fade" style={{ maxWidth: 520 }} data-testid="rebook-page">
      <div className="brand" style={{ marginBottom: 16 }}><BrandLogo brand={brand} size={34} testId="rebook-brand-logo" /><div><b style={{ fontSize: 16 }} data-testid="rebook-brand-name">{brandName(brand).toUpperCase()}</b><small>REBOOK YOUR SESSION</small></div></div>
      {!d && !err && <div className="center" style={{ minHeight: 120 }}><span className="spin" /></div>}
      {d && (
        <>
          <p style={{ color: "var(--ink)", fontSize: 15, marginBottom: 6 }}>Hey {d.firstName}, no stress about {fmt(d.missedAt, { weekday: "long", hour: "2-digit", minute: "2-digit" })}.</p>
          {d.rebooked ? (
            <>
              <h1 style={{ letterSpacing: 0, fontSize: 22 }} data-testid="rebook-done-title">You're back on.</h1>
              <div className="big num" style={{ fontSize: 28, margin: "8px 0" }} data-testid="rebook-done-time">{fmt(d.rebooked.startAt, { weekday: "long", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
              <div className="ss">{d.rebooked.title} · 60 min with Coach Alex · confirmed</div>
            </>
          ) : (
            <>
              <h1 style={{ letterSpacing: 0, fontSize: 22 }} data-testid="rebook-title">Pick a new slot for {d.title}</h1>
              <p>Only times your coach actually has free are shown. One tap and you're confirmed.</p>
              <SlotPicker data={d.days} value={slot} onChange={setSlot} />
              <button className="btn" style={{ width: "100%", padding: 14, fontSize: 15, marginTop: 16 }} disabled={busy || !slot} onClick={book} data-testid="rebook-button">
                {slot ? `Book ${fmt(slot)}` : "Choose a time above"}
              </button>
            </>
          )}
        </>
      )}
      {err && <div className="err" data-testid="rebook-error">{err}</div>}
      <p className="ss" style={{ marginTop: 18, textAlign: "center" }}><Link to="/login" style={{ fontWeight: 700 }} data-testid="rebook-login-link">Sign in to your portal</Link></p>
      <PoweredBy />
    </div>
    </Branded>
  );
}
